var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 33,
  height: 25,
  viewBox: "0 0 33 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_599_7392)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.9846 24.152L21.5679 12.788L17.8318 15.416C17.0304 15.98 15.9579 15.98 15.1446 15.416L11.4204 12.788L2.08607 24.188C2.53393 24.392 3.02893 24.5 3.53571 24.5H29.4643C29.9946 24.5 30.5132 24.38 30.9846 24.152ZM9.4875 11.42L0 4.724V20.9C0 21.476 0.129643 22.028 0.377143 22.532L9.4875 11.42ZM33 4.724L23.5243 11.408L32.6582 22.448C32.8821 21.968 33 21.44 33 20.9V4.724ZM0.542143 2.192L16.5 13.448L32.4579 2.192C32.3164 1.964 32.1514 1.748 31.9629 1.556C31.3029 0.884 30.3954 0.5 29.4643 0.5H3.53571C2.59286 0.5 1.69714 0.884 1.03714 1.556C0.848571 1.748 0.683571 1.964 0.542143 2.192Z",
  fill: "#0A3887"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_599_7392"
}, /*#__PURE__*/React.createElement("rect", {
  width: 33,
  height: 24,
  fill: "white",
  transform: "translate(0 0.5)"
})))));
export { SvgEmail as ReactComponent };
export default __webpack_public_path__ + "d9a51a35483a26fecc6bbabbe1784331.svg";